module.exports = __webpack_public_path__ + "img/top.65b6bbc3.png";